import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import confetti from 'canvas-confetti';

const OnboardingStepFinish = ({ onFinish, loading }) => {
  useEffect(() => {
    // Subtle confetti — not overwhelming
    const end = Date.now() + 1500;

    const frame = () => {
      if (Date.now() > end) return;

      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: ['#f97316', '#fb923c', '#fed7aa'],
        ticks: 200,
        gravity: 0.8,
        scalar: 0.9,
        drift: 0,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: ['#f97316', '#fb923c', '#fed7aa'],
        ticks: 200,
        gravity: 0.8,
        scalar: 0.9,
        drift: 0,
      });

      requestAnimationFrame(frame);
    };

    frame();
  }, []);

  return (
    <div className="text-center py-4">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5, ease: [0.32, 0.72, 0, 1] }}
          className="w-12 h-12 mx-auto mb-8 rounded-full bg-[#f97316] flex items-center justify-center"
        >
          <motion.svg
            className="w-6 h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.5, duration: 0.5 }}
            />
          </motion.svg>
        </motion.div>

        <h1 className="text-[2rem] sm:text-[2.5rem] font-light tracking-tight text-gray-900 mb-3">
          You're all set
        </h1>

        <p className="text-[15px] text-gray-400 leading-relaxed max-w-xs mx-auto mb-12">
          Your workspace is ready. Let's build something great.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5 }}
      >
        <button
          onClick={onFinish}
          disabled={loading}
          className="w-full py-4 bg-[#f97316] hover:bg-[#ea580c] text-white text-[15px] font-medium rounded-xl transition-colors disabled:opacity-50"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              Setting up...
            </span>
          ) : (
            'Enter your dashboard'
          )}
        </button>
      </motion.div>
    </div>
  );
};

export default OnboardingStepFinish;
